import React from "react";
import "../../style/component/LogoStrip/LogoStrip.css";
import { resolveImageSrc } from "../../utils/resolveImageSrc";
function LogoStrip({ id, title, items = [] }) {
  return (
    <section id={id} className="logostrip-section">
      <h2 className="section-title" data-translate={`${id}.title`}>
        {title}
      </h2>
      <div className="logostrip-container">
        <div className="logostrip-track">
          {items.map((it, idx) => (
            <div className="logostrip-item" key={it.id || idx}>
              <div className="logostrip-box">
                <a href={it.href} target={it.target || "_blank"} rel="noopener noreferrer">
                  <img src={resolveImageSrc(it.src)} alt={it.alt || ""} className="logostrip-logo" />
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default LogoStrip;
